import { render } from "./FaqContainer.vue?vue&type=template&id=1699ef06"
import script from "./FaqContainer.vue?vue&type=script&lang=js"
export * from "./FaqContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__